import { Grid, Stack, TextField, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../FormPagePerson';
import { FormValuesB2B } from '../FormPageB2B';

type Props<T> = {
    formik: FormikProps<T>
}

function BasicUserData<T extends FormValues | FormValuesB2B>({ formik }: Props<T>) {
    const { values, handleChange, handleBlur, errors, touched } = formik;

    return (
        <Grid container spacing={6} alignItems="flex-start" direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: { xs: "60px", lg: '150px' }, width: '100%' }}>
            <Grid size={{ xs: 12, sm: 12, md: 5 }} sx={{ height: 'auto' }}>
                <Typography variant="h6" sx={{ margin: 0, padding: '0px' }}>Dane zleceniobiorcy</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 7 }} columns={{ xs: 12, sm: 12, md: 6 }}>
                <Stack >
                    <Grid container spacing={4} direction={{ xs: 'column', sm: 'row' }}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Imię (Imiona)"
                                name="firstName"
                                value={values.firstName}
                                InputProps={{
                                    readOnly: true,
                                    style: { color: 'rgba(0, 0, 0, 0.38)' },
                                }}
                                onClick={() => alert('To pole jest tylko do odczytu')}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label="Nazwisko"
                                name="lastName"
                                value={values.lastName}
                                InputProps={{
                                    readOnly: true,
                                    style: { color: 'rgba(0, 0, 0, 0.38)' },
                                }}
                                onClick={() => alert('To pole jest tylko do odczytu')}

                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="Adres e-mail"
                                name="email"
                                value={values.email}
                                InputProps={{
                                    readOnly: true,
                                    style: { color: 'rgba(0, 0, 0, 0.38)' },
                                }}
                                onClick={() => alert('To pole jest tylko do odczytu')}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="Numer Telefonu"
                                name="phoneNo"
                                value={values.phoneNo}
                                InputProps={{
                                    readOnly: true,
                                    style: { color: 'rgba(0, 0, 0, 0.38)' },
                                }}
                                onClick={() => alert('To pole jest tylko do odczytu')}
                                // value={values.phoneNo}
                                // onChange={handleChange}
                                // onBlur={handleBlur}
                                // error={touched.phoneNo && Boolean(errors.phoneNo)}
                                // helperText={touched.phoneNo && typeof errors.phoneNo === 'string' ? errors.phoneNo : undefined}
                            />
                        </Grid>

                    </Grid>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default BasicUserData;
